import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { intersectionBy } from 'lodash';
import {
  getJiraTicketsByScenarioName,
  getJiraOpenTickets
} from './../reducers';
import AnnotationsJiraTicketComponent
  from './../Components/AnnotationsJiraTicketComponent.jsx';

export const mapStateToProps = (state, ownProps) => {
  const allScenarioTickets = getJiraTicketsByScenarioName(state, ownProps.scenarioName);
  const slicedTickets = allScenarioTickets.slice(0, 15);
  const openTickets = getJiraOpenTickets(state);

  return { jiraTickets: intersectionBy(slicedTickets, openTickets) };
};

const AnnotationsJiraTicketContainer = connect(
  mapStateToProps
)(AnnotationsJiraTicketComponent);

AnnotationsJiraTicketContainer.propTypes = { scenarioName: PropTypes.string.isRequired };

export default AnnotationsJiraTicketContainer;


// WEBPACK FOOTER //
// src/Containers/AnnotationsJiraTicketContainer.jsx